import React from "react";
import { Input, Row, Typography, Select, Form, Col, Divider } from "antd";
import { labelConfig } from "../../../product.config";
const { Title } = Typography;

const CurrencyForm = (props) => {
  const { currencyData, onFinish, form, onChange, formData } = props;
  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      form={form}
      initialValues={formData}
    >
      <Row>
        <Divider orientation="left" orientationMargin="0">
          <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
            {labelConfig.currencyInfo}
          </Title>
        </Divider>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.currency}
            name={"currencyCode"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              showSearch
              options={currencyData}
              onChange={onChange}
              allowClear
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.decimalPlaces}
            name={"digitsAfterDecimal"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.multiplesOf}
            name={"inMultiplesOf"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default CurrencyForm;
